import { SectionTextModel } from "./sectionTextModel";

export class SectionContentModel {
    textList?: Array<SectionTextModel>=[];
    
}


// WEBPACK FOOTER //
// ./src/app/model/sectionContentModel.ts